import { DragAttributesType } from "../../../../types/threeJsTypes/controlsTypes";

export const DragAttributes: DragAttributesType = {
  enabled: false,
};
